import type { JSX } from 'react';

import styles from './styles.module.css';

export function ConditionsGrid(): JSX.Element {
  return (
    <section className={styles.secPad} id="conditions">
      <div className={`${styles.wrap} ${styles.center}`}>
        <span className={styles.eyebrow}>Who qualifies</span>
        <h2 className={styles.sectionH2}>Five conditions, one referral path</h2>
        <p className={styles.condIntro}>
          NourishedRx supports the cardiometabolic conditions tracked by the ACCESS program. The
          referral form collects the relevant clinical readings to personalize the program.
        </p>
        <div className={styles.condGrid}>
          <div className={styles.cond}>
            <div className={styles.condIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <path d="M3 12h4l2 5 4-12 2 7h6" />
              </svg>
            </div>
            <strong>Hypertension</strong>
          </div>
          <div className={styles.cond}>
            <div className={styles.condIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <circle cx="12" cy="12" r="8" />
                <path d="M12 8v8M8 12h8" />
              </svg>
            </div>
            <strong>Prediabetes / Obesity</strong>
          </div>
          <div className={styles.cond}>
            <div className={styles.condIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <path d="M12 3c3 4 5 6.5 5 10a5 5 0 0 1-10 0c0-3.5 2-6 5-10Z" />
              </svg>
            </div>
            <strong>Diabetes</strong>
          </div>
          <div className={styles.cond}>
            <div className={styles.condIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <path d="M8 4c4 0 8 3 8 8s-4 8-8 8M8 4v16M8 9c3 0 5 1 5 3s-2 3-5 3" />
              </svg>
            </div>
            <strong>Chronic Kidney Disease</strong>
          </div>
          <div className={styles.cond}>
            <div className={styles.condIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10Z" />
              </svg>
            </div>
            <strong>ASCVD</strong>
          </div>
        </div>
      </div>
    </section>
  );
}
